/**
 * single-flavor js
 * js functions for the product detail page
 *
 */
(function ($) {
    SoyVay.singleFlavorPageFunctions = (function () {
        function privateInit() {
            // tab toggling
            const toggleHandler = function (el) {
                const desire = $(el).data('toggle');
                $('.deets-tab-toggle').removeClass('active');
                $(`.deets-tab-toggle.${desire}`).addClass('active');
                $(el).parent().find('li').removeClass('active');
                $(el).addClass('active');
            };

            $('.js-product-deets-tabs').on('click', 'li', function () {
                toggleHandler(this);
            });

            $('.js-product-deets-tabs').on('keydown', 'li', function (e) {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleHandler(this);
                    e.preventDefault();
                }
            });
        }
        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.singleFlavorPageFunctions.init();
    });
})(jQuery);
